export default __webpack_public_path__ + "bml-characteristic5.2128c37.png";